import { RootState } from '../../../../rootReducer';

export const counterpartySelector = (state: RootState) => state.handbookModuleReducer.CounterpartyReducer;
